import { useEffect, useState } from 'react';

import { fetchBillingSettings, saveBillingSettings, type BillingSettings } from '@/services/settings-service';

export const useBillingSettings = () => {
  const [settings, setSettings] = useState<BillingSettings | null>(null);
  const [unsavedKeys, setUnsavedKeys] = useState<(keyof BillingSettings)[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchBillingSettings()
      .then((loaded) => {
        if (cancelled) return;
        setSettings(loaded.settings);
        setUnsavedKeys(loaded.unsavedKeys);
        setIsLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Failed to load settings');
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // Rethrows a failed save so the caller can report it and keep the edits.
  const save = async (changes: Partial<BillingSettings>) => {
    await saveBillingSettings(changes);
    setSettings((current) => current && { ...current, ...changes });
    setUnsavedKeys((current) => current.filter((key) => !(key in changes)));
  };

  return { settings, unsavedKeys, isLoading, error, save };
};
